// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App-level base. Design tokens live in styles/master.css. */
body {
  min-height: 100vh;
  overflow-x: hidden;
}

/* Soften Bootstrap defaults we don't want */
.btn:focus,
.form-control:focus {
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;;EAEE,gBAAgB;AAClB","sourcesContent":["/* App-level base. Design tokens live in styles/master.css. */\nbody {\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n\n/* Soften Bootstrap defaults we don't want */\n.btn:focus,\n.form-control:focus {\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
